{
  "id": "ptax",
  "nome": "Bacen PTAX Fechamento",
  "fonte": "Banco Central Olinda PTAX API — Fechamento PTAX",
  "endpoints": [
    "https://olinda.bcb.gov.br/olinda/servico/PTAX/versao/v1/odata/CotacaoMoedaPeriodo(moeda=@moeda,dataInicial=@dataInicial,dataFinalCotacao=@dataFinalCotacao)",
    "https://olinda.bcb.gov.br/olinda/servico/PTAX/versao/v1/swagger-ui3"
  ],
  "capturadoEm": "2026-08-05",
  "atualizadoEm": "2026-08-05T05:40:22.252Z",
  "contagens": {
    "cotacoes": 850,
    "moedas": 10,
    "diasUteis": 85
  },
  "alteracoes": {
    "adicionados": 10,
    "removidos": 10,
    "alterados": 0,
    "comparadoCom": "2026-08-04"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-05T05:40:22.252Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#ptax-cotacoes",
  "janelaDiasUteis": 90
}
